import { useState } from 'react';

import { CheckBoxProps } from './types';

/**
 * It can be used in both multi-select and switch mode.
 *
 * To use it in switch mode you have to use the "isCheck" property.
 *
 * @property className: string, default: empty-string
 * @property isCheck: boolean, default: undefined
 * @property shape: circle | square, default: circle
 * @property size: small | default, default: base
 * @property value!: string
 * @property onClick(p: string): void
 */
export const Checkbox: React.FC<CheckBoxProps> = ({
  className = '',
  isCheck,
  isDisabled = false,
  shape = 'circle',
  size = 'base',
  value,
  onClick,
  formik,
  name = 'cb_name_' + Math.floor(Math.random() * 1000),
  id = 'cb_id_' + Math.floor(Math.random() * 1000),
  children,
}) => {
  const [check, setCheck] = useState(isCheck ?? false);

  const handleClick = () => {
    if (isDisabled) {
      return;
    }
    if (onClick) {
      onClick(value);
    }
    if (formik) {
      return;
    }

    setCheck(!check);
  };

  return (
    <div className={'inline-flex items-center'}>
      <label
        className={`
        ${className}
        relative
        overflow-hidden
        inline-flex
        flex-shrink-0 
        items-center
        justify-center
        border
        ${shape === 'circle' ? 'rounded-full' : 'rounded-md'}
        ${
          isCheck ?? check
            ? 'text-black bg-lime border-lime '
            : 'text-white bg-white border-grey-30 dark:bg-black-real dark:border-white dark:text-black'
        }
        ${size === 'small' ? 'w-4 h-4' : 'w-5 h-5'}
        ${isDisabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'}
      `}
        onClick={handleClick}
      >
        <svg
          width="16"
          height="16"
          viewBox="-2 0 14 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="fill-current"
        >
          <path d="M8.21969 0.468347L3.49994 5.1881L1.78019 3.46835C1.48591 3.18412 1.01813 3.18818 0.728825 3.47748C0.439525 3.76678 0.43546 4.23456 0.719689 4.52885L2.96969 6.77885C3.26256 7.07163 3.73731 7.07163 4.03019 6.77885L9.28019 1.52885C9.56442 1.23456 9.56035 0.766783 9.27105 0.477483C8.98175 0.188182 8.51397 0.184117 8.21969 0.468347Z" />
        </svg>
        {formik && (
          <input
            type="checkbox"
            value={formik.values[name]}
            checked={formik ? !!formik.values[name] : !!isCheck}
            name={name}
            onChange={(ev) => {
              formik.handleChange(ev);
              setCheck(!check);
            }}
            id={id}
            className="mr-1.5 absolute -ml-32"
            disabled={isDisabled}
          />
        )}
      </label>
      {children && <span className={'ml-2'}>{children}</span>}
    </div>
  );
};
